import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ca from './translations/ca.json';
import en from './translations/en.json';
import es from './translations/es.json';

// El català és l'idioma de l'aplicació. Només se n'usa un altre si l'usuari
// l'ha triat expressament, i es comprova que sigui un dels tres: un valor
// estrany a localStorage deixava l'aplicació en un idioma inesperat sense que
// se'n pogués sortir des de la interfície.
const IDIOMES = ['ca', 'es', 'en'];
const PER_DEFECTE = 'ca';

const getInitialLanguage = () => {
  const desat = localStorage.getItem('language');
  return IDIOMES.includes(desat) ? desat : PER_DEFECTE;
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      ca: { translation: ca },
      en: { translation: en },
      es: { translation: es }
    },
    lng: getInitialLanguage(),
    fallbackLng: PER_DEFECTE,
    supportedLngs: IDIOMES,
    interpolation: {
      escapeValue: false
    }
  });

// Save language to localStorage when it changes
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
});

export default i18n;